import { createSlice } from "@reduxjs/toolkit";

import { getDays, getQuestionTypes, getDifficultyLevel, fetchUsersByRoleID } from './thunk';

export const initialState = {
  days: [],
  questionTypes: [],
  difficultyLevel: [],
  users: [],
  error: {}
};

const commonSlice = createSlice({
  name: "common",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getDays.fulfilled, (state, action) => {
      state.days = action.payload;
    });
    builder.addCase(getDays.rejected, (state, action) => {
      state.error = action.payload.error || "Something went wrong";
    });

    builder.addCase(getQuestionTypes.fulfilled, (state, action) => {
      state.questionTypes = action.payload;
    });
    builder.addCase(getQuestionTypes.rejected, (state, action) => {
      state.error = action.payload.error || "Something went wrong";
    });

    builder.addCase(getDifficultyLevel.fulfilled, (state, action) => {
      state.difficultyLevel = action.payload;
    });
    builder.addCase(getDifficultyLevel.rejected, (state, action) => {
      state.error = action.payload.error || "Something went wrong";
    });

    builder.addCase(fetchUsersByRoleID.fulfilled, (state, action) => {
      state.users = action.payload;
    });
    builder.addCase(fetchUsersByRoleID.rejected, (state, action) => {
      state.error = action.payload.error || "Something went wrong";
    });
  },
});

export default commonSlice.reducer;